import React from 'react';

export const AdultsOnlyFingeringIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M21.0399 38.7C12.9199 38.7 6.29993 32.08 6.29993 23.96C6.29993 15.84 12.9199 9.21997 21.0399 9.21997C29.1599 9.21997 35.7799 15.84 35.7799 23.96C35.7799 32.08 29.1599 38.7 21.0399 38.7ZM21.0399 17.22C17.3199 17.22 14.2999 20.24 14.2999 23.96C14.2999 27.68 17.3199 30.7 21.0399 30.7C24.7599 30.7 27.7799 27.68 27.7799 23.96C27.7799 20.24 24.7599 17.22 21.0399 17.22Z"
        fill="#C13870"
      />
      <path d="M25.0399 34.7H17.0399V56.58H25.0399V34.7Z" fill="#C13870" />
      <path d="M31.98 41.6399H10.1V49.6399H31.98V41.6399Z" fill="#C13870" />
      <path
        d="M19.5599 37.2C11.4399 37.2 4.81995 30.58 4.81995 22.46C4.81995 14.34 11.4399 7.71997 19.5599 7.71997C27.6799 7.71997 34.2999 14.34 34.2999 22.46C34.2999 30.58 27.6799 37.2 19.5599 37.2ZM19.5599 15.72C15.8399 15.72 12.8199 18.74 12.8199 22.46C12.8199 26.18 15.8399 29.2 19.5599 29.2C23.2799 29.2 26.2999 26.18 26.2999 22.46C26.2999 18.74 23.2799 15.72 19.5599 15.72Z"
        fill="#FF6AA0"
      />
      <path d="M23.5599 33.2H15.5599V55.08H23.5599V33.2Z" fill="#FF6AA0" />
      <path d="M30.5 40.1399H8.62V48.1399H30.5V40.1399Z" fill="#FF6AA0" />
      <path
        d="M46.46 33.1802C46.46 33.1802 31.1 50.1002 33.92 51.8402C33.92 51.8402 39.54 57.6802 45.06 58.4202C53.3 59.5202 64.24 47.3802 56.12 35.9602C54.5 33.6802 48.48 29.8002 46.44 33.1802H46.46Z"
        fill="#22BDFF"
      />
      <path
        d="M46.34 38.66C47.64 39.66 49.52 39.42 50.56 38.1C51.58 36.76 51.36 34.86 50.06 33.86L31.46 19.44C30.16 18.44 28.28 18.68 27.24 20C26.22 21.34 26.44 23.24 27.74 24.24L46.34 38.66Z"
        fill="#22BDFF"
      />
      <path
        d="M49.2001 38.7601C50.2201 37.4201 49.9801 35.5201 48.6801 34.5201L30.0801 20.1001C29.3801 19.5601 28.5001 19.3801 27.6801 19.5401C28.7401 18.6201 30.3201 18.5401 31.4601 19.4201L50.0601 33.8401C51.3601 34.8401 51.6001 36.7401 50.5801 38.0601C50.1201 38.6801 49.4601 39.0601 48.7801 39.2001C48.9401 39.0601 49.0801 38.9201 49.2201 38.7401L49.2001 38.7601Z"
        fill="#0072A3"
      />
      <path
        d="M30.18 48.9401C28.84 47.9001 28.6 46.0001 29.62 44.6801L29.66 44.6401C30.68 43.3201 32.5799 43.1001 33.9199 44.1201L37.6399 47.0001C38.9599 48.0401 39.2199 49.9401 38.2 51.2601L38.1599 51.3001C37.1399 52.6201 35.24 52.8401 33.9 51.8201L30.18 48.9401Z"
        fill="#22BDFF"
      />
      <path
        d="M31.7 42.5202C30.38 41.4802 30.12 39.5802 31.14 38.2602V38.2202C32.2 36.9002 34.1 36.6802 35.42 37.7002L39.14 40.5802C40.46 41.6202 40.72 43.5202 39.7 44.8402V44.8802C38.64 46.2002 36.74 46.4202 35.42 45.4002L31.7 42.5202Z"
        fill="#22BDFF"
      />
      <path
        d="M34.6029 33.2605L34.6397 33.2131C35.6571 31.9014 37.5653 31.6603 38.877 32.6778L42.6539 35.6075C43.9656 36.6249 44.2066 38.533 43.1892 39.8447L43.1524 39.8921C42.135 41.2038 40.2268 41.4448 38.9152 40.4274L35.1382 37.4977C33.8266 36.4803 33.5855 34.5721 34.6029 33.2605Z"
        fill="#22BDFF"
      />
      <path
        d="M36.7401 51.3V51.26C37.7801 49.94 37.5201 48.08 36.2001 47.06L32.48 44.18C32.12 43.9 31.72 43.72 31.3 43.62C32.18 43.4 33.16 43.56 33.94 44.18L37.6601 47.06C38.9801 48.1 39.2401 49.94 38.2201 51.26H38.2001C37.4601 52.26 36.24 52.64 35.12 52.38C35.74 52.22 36.3201 51.86 36.7401 51.32V51.3Z"
        fill="#0072A3"
      />
      <path
        d="M38.26 44.8801H38.28C39.3 43.5401 39.06 41.6801 37.74 40.6401L34.02 37.7401C33.66 37.4601 33.26 37.2801 32.84 37.1801C33.72 36.9601 34.7 37.1201 35.48 37.7201L39.2 40.6201C40.52 41.6601 40.76 43.5001 39.74 44.8201V44.8601C38.98 45.8201 37.76 46.2001 36.64 45.9401C37.26 45.7801 37.84 45.4201 38.26 44.8801Z"
        fill="#0072A3"
      />
      <path
        d="M41.7201 39.8801H41.7401C42.7601 38.5401 42.5401 36.6601 41.2001 35.6401L37.48 32.7401C37.12 32.4601 36.72 32.2801 36.3 32.1801C37.18 31.9601 38.16 32.1201 38.94 32.7401L42.6601 35.6401C43.9801 36.6801 44.2001 38.5201 43.1801 39.8401V39.8801C42.4201 40.8401 41.2001 41.2201 40.0801 40.9601C40.7001 40.8001 41.2801 40.4401 41.7001 39.9001L41.7201 39.8801Z"
        fill="#0072A3"
      />
      <path
        d="M48.34 38.1001C44.92 39.7801 42.42 47.6601 49 50.8601C43.12 46.3001 46.24 40.2201 48.34 38.1001Z"
        fill="#0072A3"
      />
      <path
        d="M41.72 34.62C39.04 35.66 40.58 37.48 38.1 40.86C37.02 42.34 39.52 45.32 42.32 43.96C46.2 42.08 44.24 40.18 45.66 40.08C47.16 39.98 47.92 39.36 49.46 39.5C50.58 39.6 52.38 34.9 51.16 33.32C48.82 30.26 45.96 32.96 41.72 34.62Z"
        fill="#0072A3"
      />
      <path
        d="M42.42 34.76C39.64 35.84 41.24 37.72 38.66 41.26C37.54 42.8 40.14 45.9 43.04 44.48C47.08 42.52 45.04 40.54 46.52 40.44C48.08 40.34 48.86 39.7 50.48 39.84C51.64 39.94 53.54 43.56 53.54 43.56C53.54 43.56 59.32 41.8 58.36 39.78C56.6 36.04 53.98 34.68 52.24 33.4C48.22 30.44 46.84 33.02 42.42 34.74V34.76Z"
        fill="#22BDFF"
      />
      <path
        d="M47.4199 32.3601C50.0999 30.9601 55.6199 35.4201 57.0799 39.1401C60.6999 48.3601 53.7599 57.0601 46.9399 58.4401C54.0599 57.7801 61.7399 48.7401 58.1399 38.9801C56.6999 35.0601 50.7399 29.5601 47.4199 32.3601Z"
        fill="#0072A3"
      />
      <path
        d="M50.2 40.36C50.56 40.4 51 40.76 51.42 41.24C50.84 40.42 50.16 39.64 49.62 39.6C48.02 39.46 47.48 39.68 45.92 39.8C44.44 39.9 46.48 41.88 42.44 43.84C40.94 44.56 39.54 44.1 38.66 43.26C39.34 44.5 41.1 45.52 43.02 44.6C47.06 42.64 45.02 40.66 46.5 40.56C48.06 40.46 48.6 40.22 50.2 40.36Z"
        fill="#0072A3"
      />
    </svg>
  );
};
